import { JobsSharedModule } from './../jobs/jobs-shared.module';
import { AuditSharedModule } from './../audit/audit-shared.module';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ClimbCommonModule } from '../common/climb-common.module';
import { ClimbServicesModule } from '../services/climb-services.module';

import { OrderService } from './order.service';
import { OrderVocabService } from './order-vocab.service';
import { OrderFilterComponent } from './filter/order-filter.component';
import { OrderMultiselectComponent } from './order-multiselect.component';
import { UsersSharedModule } from '../user/users-shared.module';
import { LinesSharedModule } from '../lines/lines-shared.module';
import { JobOrderService } from '../jobs/job-order.service';
import { OrderSelectComponent } from './orders-detail/components/order-select/order-select.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ClimbCommonModule,
        ClimbServicesModule,
        AuditSharedModule,
        JobsSharedModule,
        LinesSharedModule,
        UsersSharedModule
    ],
    declarations: [
        OrderFilterComponent,
        OrderSelectComponent,
        OrderMultiselectComponent
    ],
    exports: [
        OrderFilterComponent,
        OrderSelectComponent,
        OrderMultiselectComponent
    ]
})
export class OrdersSharedModule {
    static forRoot(): ModuleWithProviders<OrdersSharedModule> {
        return {
          ngModule: OrdersSharedModule,
          providers: [
            OrderService,
            JobOrderService,
            OrderVocabService,
          ]
        };
    }
}
